<template>
  <div class="tab">
    <h3>心理弹性干预</h3>
    <div>
      <List :listArr="listArr" v-if="listOrCon"></List>
      <router-view v-if="!listOrCon"></router-view>
    </div>
  </div>
</template>
<script>
import List from "../list/list";
export default {
  name: "psychological",
  data() {
    return {
      listArr: [
        {
          title: "提升心理弹性，促进积极发展",
          path: "psychological1",
          img: [require("../../assets/list1.png")],
          id: 1
        },
        {
          title: "促进处境不利儿童积极发展，我们在科研和实践的道路上",
          path: "psychological2",
          img: [require("../../assets/list2.png")],
          id: 2
        },
        {
          title: "心理弹性项目培训项目",
          path: "psychological3",
          img: [require("../../assets/list3.png")],
          id: 3
        }
      ],
      listOrCon: true
    };
  },
  watch: {
    $route(to, from) {
      if (to.matched.length == 3) {
        this.listOrCon = false;
        this.currentRouter = to.path;
      } else {
        this.listOrCon = true;
      }
    }
  },
  created() {
    if (this.$route.matched.length == 3) {
      this.listOrCon = false;
    }
  },
  components: {
    List
  }
};
</script>

<style scoped src="../../assets/style/grandchild.css">
/* @import '../assets/style/child.css'; */
</style>



// WEBPACK FOOTER //
// src/components/tabs/psychological.vue